module.exports = __webpack_public_path__ + "img/bg2@2x (1).378d67af.png";